module.exports = __webpack_public_path__ + "static/media/et.2ebb0d3d.svg";